import React, { useContext, useEffect } from 'react';
import { PostHogProvider, usePostHog } from 'posthog-js/react';
import { ConfigContext, auth, parseJwt } from './base-ui/lib.js';
import posthog from 'posthog-js';

export function PosthogWrapper(props: { children: any }) {
	const { config }: any = useContext(ConfigContext);

	const isLocalDev = config.environmentName === 'local_dev';
	const apiKey = config?.analytics?.publicKey;
	const apiHost = config?.analytics?.host;
	const shouldInitializePostHog = !!(apiKey && apiHost && !isLocalDev);

	if (shouldInitializePostHog) {
		posthog.init(apiKey, {
			api_host: apiHost,
			defaults: '2025-05-24',
		});
	}

	return (
		<>
			{!shouldInitializePostHog && <>{props.children}</>}
			{shouldInitializePostHog && (
				<PostHogProvider client={posthog}>
					<PostHogUser>{props.children}</PostHogUser>
				</PostHogProvider>
			)}
		</>
	);
}

function PostHogUser({ children }: { children: any }) {
	const posthog = usePostHog();
	const token: any = auth.getBearerToken();

	useEffect(() => {
		if (posthog && token) {
			const parsedJWT = parseJwt(token);

			posthog.identify(parsedJWT.sub, {
				userId: parsedJWT.sub,
				roles: parsedJWT.role,
				tenantId: parsedJWT.tenantId,
				email: parsedJWT.email,
				company: parsedJWT.company,
			});
		}

		return () => {
			// Reset PostHog on unmount (e.g., logout or page change)
			posthog?.reset();
		};
	}, [posthog, token]);

	return <>{children}</>;
}
